import { VENDOR_PROFILE_STATUSES, VENDOR_PROFILE_STATUSES_VALUES } from 'domain/finance/vendors/constants';
import { Badge, type BadgeProps } from 'framework/ui/mui-builder';

const VENDOR_PROFILE_STATUSES_COLOR: Record<VENDOR_PROFILE_STATUSES, BadgeProps['color']> = {
  [VENDOR_PROFILE_STATUSES.DRAFT]: 'default',
  [VENDOR_PROFILE_STATUSES.APPROVED]: 'secondary',
  [VENDOR_PROFILE_STATUSES.FINALIZED]: 'success',
};

const VendorProfileStatusBadge = ({ status }: { status: VENDOR_PROFILE_STATUSES }) => (
  <Badge id="vendorProfileStatus" color={VENDOR_PROFILE_STATUSES_COLOR[status] || 'default'}>
    {VENDOR_PROFILE_STATUSES_VALUES[status]}
  </Badge>
);

export default VendorProfileStatusBadge;
